<img class="{{imageclass}}"
      [src]="imageToShow"
      matTooltip={{alt}}
      *ngIf="!isImageLoading"/>
  